import * as NodeHttpClient from '@effect/platform-node/NodeHttpClient';
import * as PlatformNodeServices from '@effect/platform-node/NodeServices';
import { Layer } from 'effect';
import type { HttpClient } from 'effect/unstable/http/HttpClient';

/** Upstream Node implementations for Effect's portable platform services. */
export const nodeServicesLayer = PlatformNodeServices.layer;

/** Fetch-compatible Effect HttpClient for CLI network boundaries. */
export const nodeHttpClientLayer = NodeHttpClient.layerFetch;

export type NodePlatformServices = PlatformNodeServices.NodeServices | HttpClient;

/** One process-level platform stack for Node-only CLI composition roots. */
export const nodePlatformLayer: Layer.Layer<NodePlatformServices> = Layer.merge(
  nodeServicesLayer,
  nodeHttpClientLayer,
);
